import React from 'react';
import {
  DescriptionItem,
  Grid,
  Section,
  ToggleButton,
  DescriptionList,
} from '@gogame/components';
import {
  useFormContext,
  FormField,
  withFormFieldGroupFormField,
} from '@gogame/form';
import { BUSINESS_PARTNER, INVOICE_PROCESSING_RULE } from './constants';
import { useHierarchyArea } from '@plarium/hierarchy-react';
import { loadBusinessPartnerDetails } from '../../sources/fields';

export const RULE_TYPE = 'type';
export const RULE_VALUE = 'value';

export const TYPE_INHERIT = 0;
export const TYPE_DOMAIN = 1;
export const TYPE_KEYWORDS = 2;

function isAffiliateLevel({ invoiceLevel }) {
  return invoiceLevel === 'Affiliate';
}
function normalizeInvoiceProcessingRule(value, data) {
  if (isAffiliateLevel(data?.[0])) {
    return (
      value || {
        [RULE_TYPE]: TYPE_INHERIT,
      }
    );
  }
  return null;
}

function mapParams(values) {
  return { id: values[BUSINESS_PARTNER] };
}

export const InvoiceProcessingRuleSection = withFormFieldGroupFormField({
  name: INVOICE_PROCESSING_RULE,
})(({ value, active }) => {
  const { data } = useHierarchyArea({
    name: INVOICE_PROCESSING_RULE,
    params: mapParams,
    source: loadBusinessPartnerDetails,
    depends: [BUSINESS_PARTNER],
    active: active,
    normalizeValue: normalizeInvoiceProcessingRule,
  });
  const invoiceProcessingRuleInherit = data?.[0];

  const { setFieldValue } = useFormContext();

  const handleChangeRuleType = () => {
    setFieldValue(`${INVOICE_PROCESSING_RULE}.${RULE_VALUE}`, undefined);
  };

  if (!value) {
    return null;
  }
  return (
    <Section
      title={'Invoice Processing Rule'}
      subTitle={
        'Automatic rule to identify Business Partners from invoice emails.'
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormField.ToggleButtonGroup
            size={'small'}
            color={'primary'}
            name={RULE_TYPE}
            padding={0}
            onChange={handleChangeRuleType}
          >
            <ToggleButton value={TYPE_INHERIT}>
              Inherit from Business Partner
            </ToggleButton>
            <ToggleButton value={TYPE_KEYWORDS}>
              Keywords in email subject
            </ToggleButton>
            <ToggleButton value={TYPE_DOMAIN}>
              Invoice sender domain
            </ToggleButton>
          </FormField.ToggleButtonGroup>
        </Grid>
        {value?.[RULE_TYPE] === TYPE_INHERIT && (
          <Grid item xs={12}>
            <DescriptionList disableGutters data={invoiceProcessingRuleInherit}>
              <DescriptionItem
                field={'invoiceProcessingRuleKeywords'}
                label={'Keywords in email subject'}
                type={'text'}
              />
              <DescriptionItem
                field={'invoiceProcessingRuleSenderDomain'}
                label={'Invoice sender domain'}
                type={'text'}
              />
            </DescriptionList>
          </Grid>
        )}
        {value?.[RULE_TYPE] === TYPE_KEYWORDS && (
          <Grid item xs={12}>
            <FormField.TextField
              size={'small'}
              color={'primary'}
              placeholder={'Keywords in email subject'}
              helperText={
                'Enter keywords that indicate Business Partner information in invoice emails. Use commas to separate multiple keywords.'
              }
              name={RULE_VALUE}
              padding={0}
            />
          </Grid>
        )}
        {value?.[RULE_TYPE] === TYPE_DOMAIN && (
          <Grid item xs={12}>
            <FormField.TextField
              size={'small'}
              color={'primary'}
              placeholder={'Invoice sender domain'}
              helperText={
                'Enter the domain (the part after "@") of the sender’s email address.'
              }
              name={RULE_VALUE}
              padding={0}
            />
          </Grid>
        )}
      </Grid>
    </Section>
  );
});
